import React from 'react'

export const easeInOutCubic = (percentComplete) =>
  percentComplete < 0.5
    ? Math.pow(percentComplete * 2, 3) / 2
    : 1 - Math.pow((1 - percentComplete) * 2, 3) / 2

const minimumTransitionLengthInMillis = 200
const maximumTransitionLengthInMillis = 1200

interface ChildProps {
  readonly onScrollToTopClick: () => void
  readonly showScrollToTopButton: boolean
  readonly handleScroll: (props: { readonly scrollTop: number }) => void
  readonly registerListRef: (listRef: any) => void
}

interface Props {
  readonly headerHeight: number
  readonly children: (props: ChildProps) => React.ReactNode
}

interface State {
  readonly scrollTop: number
}

export class GridScroller extends React.Component<Props, State> {
  public readonly state: State = {
    scrollTop: 0
  }

  private listRef: any
  private scrollAnimationID: number = 0

  public render() {
    const { children, headerHeight } = this.props

    return children({
      onScrollToTopClick: this.scrollToTop,
      showScrollToTopButton: this.state.scrollTop > headerHeight,
      handleScroll: this.handleScroll,
      registerListRef: this.registerListRef
    })
  }

  private registerListRef = (ref) => {
    this.listRef = ref
  }

  private handleScroll = ({ scrollTop }) => {
    this.setState({ scrollTop })
  }

  private scrollToTop = () => {
    if (this.scrollAnimationID) {
      return
    }

    const scrollTop = this.state.scrollTop

    /**
     * total time it takes to scroll at approx 3px/ms, with a min
     * of {@see minimumTransitionLengthInMillis} ms and a max of {@see maximumTransitionLengthInMillis} ms
     */
    const duration = Math.max(
      minimumTransitionLengthInMillis,
      Math.min(maximumTransitionLengthInMillis, scrollTop / 3)
    )

    let startTime = 0
    const step = (currentTime) => {
      if (!startTime) {
        // approximately one frame prior (at 60fps)
        startTime = currentTime - 17
      }

      const percentComplete = (currentTime - startTime) / duration

      if (percentComplete < 1) {
        this.scrollAnimationID = requestAnimationFrame(step)
        this.listRef.scrollToPosition(
          scrollTop - scrollTop * easeInOutCubic(percentComplete)
        )
      } else {
        this.listRef.scrollToPosition(0)
        this.scrollAnimationID = 0
      }
    }

    this.scrollAnimationID = requestAnimationFrame(step)
  }
}
